import React, { useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";

import CompanyPaymentsPage from "@/components/screens/CompanyPayments";
import CustomerFormPage from "@/components/screens/CustomerFormPage";
import {
  COMPANY_PAYMENTS_MESSAGES,
  CompanyPaymentsMessages,
} from "@/messages/customer/company-payments.messages";
import { CUSTOMER_DETAILS_MESSAGES, CustomerMessages } from "@/messages/customer/customer.messages";
import translationService from "@/services/translation.service";
import { Language, Translation } from "@/types/language.types";

const CompanyPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams();
  const [messages, setMessages] = useState<Translation<CustomerMessages> | null>(null);
  const [paymentsMessages, setPaymentsMessages] =
    useState<Translation<CompanyPaymentsMessages> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const [customerTranslations, paymentTranslations] = await Promise.all([
          translationService.get<CustomerMessages>(
            CUSTOMER_DETAILS_MESSAGES,
            (lang as Language) ?? null
          ),
          translationService.get<CompanyPaymentsMessages>(
            COMPANY_PAYMENTS_MESSAGES,
            (lang as Language) ?? null
          ),
        ]);
        setMessages(customerTranslations);
        setPaymentsMessages(paymentTranslations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null;
  }

  if (!messages || !paymentsMessages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return (
    <Routes>
      <Route path="/payments/:lang" element={<CompanyPaymentsPage messages={paymentsMessages} />} />
      <Route path="/:lang" element={<CustomerFormPage messages={messages} />} />
      <Route path="/" element={<CustomerFormPage messages={messages} />} />
    </Routes>
  );
};

export default CompanyPage;
